export function generateLoadingAnimation({
  numSegments,
  endIntervalDuration,
  startIntervalDuration,
  onAnimationStateChange,
  onAnimationTick,
}: {
  numSegments: number;
  endIntervalDuration: number;
  startIntervalDuration: number;
  onAnimationStateChange: (shuffling: boolean) => void;
  onAnimationTick: VoidFunction;
}) {
  const timeoutMillis = 3000 / numSegments;
  const step = (startIntervalDuration - endIntervalDuration) / (numSegments - 1);

  let interval: NodeJS.Timeout | null = null;
  return Array.from({ length: numSegments }, (_, i) => startIntervalDuration - i * step).reduce(
    (acc, cur) => {
      if (cur > endIntervalDuration) {
        return () => {
          setTimeout(() => {
            if (interval) {
              clearInterval(interval);
            }
            interval = setInterval(onAnimationTick, cur);
            acc();
          }, timeoutMillis);
        };
      }
      return () => {
        onAnimationStateChange(true);
        interval = setInterval(onAnimationTick, cur);
        acc();
      };
    },
    () => {
      setTimeout(() => {
        onAnimationStateChange(false);
        if (interval) {
          clearInterval(interval);
        }
        interval = null;
      }, timeoutMillis);
    },
  );
}

export function randomIndex(array: unknown[]) {
  return Math.floor(Math.random() * array.length);
}

export function formatTime(seconds: number) {
  if (seconds >= 60) {
    return `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, "0")}`;
  }

  return `00:${String(seconds % 60).padStart(2, "0")}`;
}
